import { motion } from "framer-motion";

const easing = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", as: Tag = "div" }) {
  const MTag = motion[Tag] || motion.div;
  return (
    <MTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: easing, delay }}
    >
      {children}
    </MTag>
  );
}

// Masked line-by-line reveal for large headlines
export function LineReveal({ lines = [], className = "", lineClassName = "", delay = 0 }) {
  return (
    <span className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden" aria-hidden="true">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, ease: easing, delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
